export default __webpack_public_path__ + "static/media/The Tome of Storms.fe22f271.jpg";